import React from "react";
import "./AwardPage.css";
import Navbar from "../../components/Navbar/Navbar";
export default function SanjayTandon() {
  return (
    <>
      <section
        id="award-inner-section"
        className="award-inner-section inner-banner">
        <Navbar />
        <div className="page-title-area">
          <div className="container-fluid pe-4 h-100 d-flex justify-content-end align-items-end">
            <div className="page-title-content">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Awards & Scholarships</li>
                <li>The Sanjay Tandon Memorial Scholarship</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container pt-5">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="main-heading text-center pb-1">
                <h1 className="main-title wow animate__animated animate__fadeInUp">
                  The Sanjay Tandon Memorial Scholarship
                </h1>
                {/* <p className="main-text wow animate__animated animate__fadeInUp">
                                    NAB Delhi has been nationally and internationally recognized for its pioneering work
                                    in the interest of the visually impaired people. Among many awards and
                                    felicitations, the two key awards which NAB has received are following
                                </p> */}
              </div>
              <p>
                The Sanjay Tandon Memorial Scholarship is instituted by Mrs &
                Mr. K. C. Tandon in the loving memory of their son Mr. Sanjay
                Tandon, who was suffering from Retinitus Pigmentosa and passed
                away at a young age. The objective of this scholarship is to
                provide financial assistance for higher education to meritorious
                visually impaired students from economically weaker sections of
                the society.
              </p>
              <p>
                Since its inception in 2007, this scholarship scheme has
                positively impacted the lives of many visually impaired students
                by providing them with much needed financial assistance to
                complete their education.
              </p>
              <p>
                Applications are invited for the Sanjay Tandon Memorial
                Scholarship by NAB Delhi every year in the months of
                July-August. A committee has been constituted by NAB Delhi with
                representation from the Tandon family to select deserving
                candidates from the applicants.
              </p>
              <p>
                Please contact us for more information on this scholarship
                scheme or to start similar schemes for visually impaired
                students.
              </p>
            </div>
          </div>
        </div>

        <div className="container pt-3">
          <div className="row">
            <div className="col-12">
              <div className="main-heading text-center pb-1">
                <h2 className="main-title wow animate__animated animate__fadeInUp">
                  Awardees
                </h2>
              </div>
            </div>

            <div className="col-md-4 mb-4">
              <div className="sd-card">
                <h3>2026-2027</h3>

                <ul className="mt-3 ps-4">
                  <li>Ranjan Kumar</li>
                  <li>Sakun Kumar</li>
                  <li>Anita Munda</li>
                  <li>Seema Kumari</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="sd-card">
                <h3>2025-2026</h3>

                <ul className="mt-3 ps-4">
                  <li>Bano Kumar Mahto</li>
                  <li>Ranjan Kumar</li>
                  <li>Priya</li>
                  <li>Ayush Kumar Singh</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="sd-card">
                <h3>2024-2025</h3>

                <ul className="mt-3 ps-4">
                  <li>Sneha</li>
                  <li>Rohit Yadav</li>
                  <li>Ritika Gupta</li>
                  <li>Shailendra</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="sd-card">
                <h3>2023 - 2024</h3>

                <ul className="mt-3 ps-4">
                  <li>Sneha</li>
                  <li>Rohit Yadav</li>
                  <li>Ayushi Singh</li>
                  <li>Abhishek Rai</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="sd-card">
                <h3>2022 - 2023</h3>

                <ul className="mt-3 ps-4">
                  <li>Ayushi Singh</li>
                  <li>Jeeramani Mahto</li>
                  <li>Ritesh Kumar</li>
                  <li>Abhishek Rai</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
